import { createContext, useContext } from 'react';

export const MapClickContext = createContext(null);

export function useMapClick() {
    return useContext(MapClickContext);
}
